<template>
  <div class="bg-custom">
    <v-row>
      <v-col cols="12" class="px-0 pt-0">
        <v-sheet color="white" class="pa-2">
          <div class="px-6 pb-5">
            <v-card-actions class="pa-0">
              <h2>{{ $vuetify.lang.t('$vuetify.company.companyTabbar') }}</h2>
            </v-card-actions>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-card class="bg-custom main-card px-5" elevation="0">
      <!-- <v-row>
        <v-col cols="12">
          <p class="mb-0">
            {{ $vuetify.lang.t('$vuetify.company.info1') }}
          </p>
        </v-col>
      </v-row> -->
      <v-row>
        <v-col cols="3" class="pr-1">
          <v-sheet color="white" elevation="0" class="sheet-style">
            <v-toolbar flat dark color="rgb(51, 97, 137)" class="toolbar-style">
              <v-toolbar-title>{{
                $vuetify.lang.t('$vuetify.company.menuList')
              }}</v-toolbar-title>
            </v-toolbar>

            <draggable
              :list="menuList"
              class="list-group"
              ghost-class="ghost"
              @end="checkMoveMenu"
            >
              <div v-for="(item, index) in menuList" :key="index" id="myDIV">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-card
                      v-on="on"
                      :class="
                        itemToedit._id == item._id
                          ? 'mx-auto my-3 card-item border-active'
                          : 'mx-auto my-3 card-item '
                      "
                      max-width="90%"
                      outlined
                      @click="openModal(item)"
                    >
                      <v-list-item>
                        <v-list-item-icon>
                          <v-icon color="black">{{ icon[item.icon] }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="">{{
                            item.name
                          }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on">
                                <v-icon color="grey lighten-1"
                                  >mdi-dots-horizontal</v-icon
                                >
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="openDelDialog(item._id)">
                                <v-list-item-icon class="mr-2">
                                  <v-icon small color="error">
                                    mdi-delete
                                  </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="
                                      font-weight-light
                                      subtitle-2
                                      error--text
                                      text-capitalize
                                    "
                                    >{{
                                      $vuetify.lang.t('$vuetify.company.delete')
                                    }}</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-list-item-action>
                      </v-list-item>
                    </v-card>
                  </template>
                  <span>{{ $vuetify.lang.t('$vuetify.company.hover1') }}</span>
                </v-tooltip>
              </div>
            </draggable>
            <v-card
              class="mx-auto my-3 border-card"
              max-width="90%"
              outlined
              @click="
                $store.state.permission.superAdmin ||
                $store.state.permission.adminCompany
                  ? openModal(null)
                  : noPermission()
              "
            >
              <v-list-item class="text-center">
                <v-list-item-content>
                  <v-list-item-title class="text-active font-weight-bold"
                    ><v-icon class="text-active"> mdi-plus </v-icon
                    >{{
                      $vuetify.lang.t('$vuetify.company.addMenu')
                    }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-sheet>
        </v-col>
        <v-col cols="9" class="pl-1" v-show="menuListClicked">
          <v-sheet color="white" elevation="0" class="sheet-style">
            <!-- <v-card
              v-if="newMenu == true"
              tile
              color="rgba(74, 144, 226, 0.5)"
              outlined
              width="100%"
              class="bg-color"
            >
              <v-toolbar flat class="toolbar-style">
                <v-toolbar-title class="primary--text">{{
                  $vuetify.lang.t('$vuetify.company.newMenu')
                }}</v-toolbar-title>
              </v-toolbar>
            </v-card> -->
            <v-card v-if="newMenu == false" tile width="100%">
              <v-toolbar
                flat
                dark
                color="rgb(51, 97, 137)"
                class="toolbar-style"
              >
                <v-toolbar-title
                  ><v-icon left>{{ icon[itemToedit.icon] }}</v-icon
                  >{{ itemToedit.name }}</v-toolbar-title
                >
              </v-toolbar>
            </v-card>
            <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
              <v-row class="px-5">
                <v-col cols="6">
                  <p class="mb-2 body-1 font-weight-medium text-custom-title">
                    {{ $vuetify.lang.t('$vuetify.company.menuName') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-text-field
                    outlined
                    v-model="menu_title"
                    :rules="nameRules"
                    :placeholder="$vuetify.lang.t('$vuetify.company.menuName')"
                    required
                    clearable
                    background-color="white"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <p class="mb-2 body-1 font-weight-medium">
                    {{ $vuetify.lang.t('$vuetify.company.templateType') }}
                  </p>
                  <v-autocomplete
                    v-model="selectedSection"
                    :items="type_item"
                    item-text="type_name"
                    item-value="value"
                    outlined
                    :placeholder="$vuetify.lang.t('$vuetify.company.msg18')"
                    :rules="sectionRules"
                    @change="changType"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
            <div v-if="selectedSection == 'overview'">
              <v-row class="px-5">
                <v-col cols="12" class="pt-0">
                  <p class="mb-0 font-weight-bold">
                    {{ $vuetify.lang.t('$vuetify.company.elementList') }}
                  </p>
                  <!-- <p class="mb-0">
                    {{ $vuetify.lang.t('$vuetify.company.info2') }}
                  </p> -->
                  <draggable
                    :list="ele_list"
                    class="list-group"
                    ghost-class="ghost"
                    @end="checkMoveElement(itemToedit)"
                  >
                    <div v-for="(item, i) in ele_list" :key="i">
                      <!-- <v-tooltip top>
                        <template v-slot:activator="{ on }"> -->
                      <v-card
                        class="mx-auto my-3"
                        max-width="100%"
                        outlined
                        @click="openElementModal(item)"
                      >
                        <v-list-item>
                          <v-list-item-icon>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="grey lighten-1">
                                  mdi-menu
                                </v-icon>
                              </template>
                              <span>{{
                                $vuetify.lang.t('$vuetify.company.hover2')
                              }}</span>
                            </v-tooltip>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title>{{
                              item.title
                            }}</v-list-item-title>

                            <v-list-item-subtitle>{{
                              item.type
                            }}</v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-menu offset-y>
                              <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                  <v-icon color="grey lighten-1"
                                    >mdi-dots-horizontal</v-icon
                                  >
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="opendelModal(item)">
                                  <v-list-item-icon class="mr-2">
                                    <v-icon small color="error">
                                      mdi-delete
                                    </v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="
                                        font-weight-light
                                        subtitle-2
                                        error--text
                                        text-capitalize
                                      "
                                      >{{
                                        $vuetify.lang.t(
                                          '$vuetify.company.delete'
                                        )
                                      }}</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-action>
                        </v-list-item>
                      </v-card>
                      <!-- </template>
                        <span>Click to edit</span>
                      </v-tooltip> -->
                    </div>
                  </draggable>
                  <v-card
                    class="mx-auto my-3 border-card"
                    max-width="100%"
                    outlined
                    @click="openElementModal(null)"
                  >
                    <v-list-item class="text-center">
                      <v-list-item-content>
                        <v-list-item-title class="text-active font-weight-bold"
                          ><v-icon class="text-active"> mdi-plus </v-icon
                          >{{
                            $vuetify.lang.t('$vuetify.company.addElement')
                          }}</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="my-2 float-right">
            <v-btn
              elevation="0"
              class="
                px-9
                ma-2
                subtitle-2
                button-secondary
                font-weight-light
                text-capitalize
              "
              @click="closeDialog"
              outlined
              dark
              large
              >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
            >
            <v-btn
              elevation="0"
              class="
                px-10
                ma-2
                subtitle-2
                text-capitalize
                font-weight-light
                button-primary
              "
              large
              :disabled="!valid"
              @click="validate"
              >{{
                newMenu == false
                  ? $vuetify.lang.t('$vuetify.company.save')
                  : $vuetify.lang.t('$vuetify.company.add')
              }}</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <!-- start old ui -->
      <!-- <v-row>
        <v-col class="py-0" :lg="12" :md="12" :sm="12">
          <v-alert class="mt-6" text type="info" border="left">
            <div>
              <strong>"การเพิ่มเมนู"</strong>
              <span> ต้องมี "Setting Menu"</span>
            </div>
          </v-alert>
        </v-col>
      </v-row>
      <div class="d-flex list-menu">
        <div
          class="menu-item mb-10"
          @click="
            $store.state.permission.superAdmin ||
            $store.state.permission.adminCompany
              ? openModal(null)
              : noPermission()
          "
        >
          <div class="content text-center">
            <v-icon class="font-weight-medium" color="#81C784">mdi-plus</v-icon>
            <p class="mb-0 green--text lighten-4 font-weight-medium">
              Add Menu
            </p>
          </div>
        </div>

        <div
          class="menu-item mb-10"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="del-com" @click="openDelDialog(item._id)">
            <v-icon color="#fff" style="font-size: 16px; padding-bottom: 8px"
              >mdi-close</v-icon
            >
          </div>
          <div class="content-panel" @click="openModal(item)">
            <div class="content text-center">
              <v-icon color="#4a4a4a" class="font-weight-medium">{{
                icon[item.icon]
              }}</v-icon>
              <p class="mb-0 font-weight-medium">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div> -->
      <!-- End old ui -->
    </v-card>

    <v-dialog v-model="dialog" persistent scrollable max-width="450px">
      <v-card>
        <v-card-title>Add New Tabbar</v-card-title>
        <v-divider></v-divider>
        <v-card-text v-bind:style="heightCard">
          <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
            <v-row>
              <v-col>
                <p class="mb-2 body-1 font-weight-medium">Template Type</p>
                <v-autocomplete
                  v-model="selectedSection"
                  :items="type_item"
                  item-text="type_name"
                  item-value="value"
                  outlined
                  placeholder="Please Choose the Type Menu"
                  :rules="sectionRules"
                  @change="changType"
                ></v-autocomplete>
                <p class="mb-2 body-1 font-weight-medium">icon</p>
                <v-autocomplete
                  v-model="selectedIcon"
                  :items="icon_list"
                  outlined
                  color="blue-grey lighten-2"
                  item-text="icon_name"
                  item-value="icon_name"
                  height="40"
                  placeholder="Please Choose the Icon"
                >
                  <template v-slot:selection="data">
                    <v-avatar left>
                      <v-icon>{{ icon[data.item.icon_name] }}</v-icon>
                    </v-avatar>
                    {{ data.item.icon_name }}
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar>
                        <v-icon>{{ icon[data.item.icon_name] }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.icon_name"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
                <p class="mb-2 body-1 font-weight-medium">Menu Name</p>
                <v-text-field
                  placeholder="Please Fill Menu Name"
                  v-model="menu_title"
                  :rules="nameRules"
                  outlined
                  required
                ></v-text-field>

                <div v-if="selectedSection == 'overview'">
                  <v-divider></v-divider>
                  <v-row class="mt-2">
                    <v-col lg="6" cols="8">
                      <p class="pt-2 body-1 font-weight-medium">
                        ELEMENT SECTION LIST
                      </p>
                    </v-col>
                    <v-col lg="6">
                      <v-btn
                        elevation="0"
                        @click="openElementModal(null)"
                        width="100%"
                        outlined
                        color="primary"
                      >
                        <v-icon left>mdi-plus</v-icon>New Element
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-card class="have-border px-2" elevation="0">
                    <v-list class="ele-list" v-if="ele_list.length > 0">
                      <v-list-item-group color="primary">
                        <v-list-item v-for="(item, i) in ele_list" :key="i">
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.title"
                            ></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-icon>
                            <v-btn
                              elevation="0"
                              class="mb-0 body-2 text-primary text-capitalize"
                              color="white"
                              @click="openElementModal(item)"
                            >
                              <p class="mb-0">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.courseList.edit'
                                  )
                                }}
                              </p>
                            </v-btn>
                            <v-divider
                              inset
                              vertical
                              class="mb-2 mx-1"
                            ></v-divider>
                            <v-btn
                              elevation="0"
                              class="mb-0 body-2 text-primary text-capitalize"
                              color="white"
                              @click="opendelModal(item)"
                            >
                              <p class="mb-0">Delete</p>
                            </v-btn>
                          </v-list-item-icon>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                    <!-- <div class="item" v-if="ele_list.length > 0">
                      <div v-for="(item, i) in ele_list" :key="i">
                        <v-row>
                          <v-col class="py-0" lg="6" cols="6">
                            <p class="mb-0">{{item.title}}</p>
                          </v-col>
                          <v-col class="py-0" lg="6" cols="6">
                            <v-btn
                              elevation="0"
                              class="mb-0 body-2 text-primary text-capitalize"
                              color="white"
                              @click="openElementModal(item)"
                            >
                              <p
                                class="mb-0"
                              >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.edit')}}</p>
                            </v-btn>
                            <v-divider inset vertical class="mb-2 mx-1"></v-divider>
                            <v-btn
                              elevation="0"
                              class="mb-0 body-2 text-primary text-capitalize"
                              color="white"
                              @click="openElementModal(item)"
                            >
                              <p class="mb-0">Delete</p>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </div>-->
                    <div class="text-center py-2" v-else>
                      <p class="mb-0 text-grey">No content yet.</p>
                      <p class="mb-0 text-grey">
                        Please click "+ New Element" button to add content.
                      </p>
                    </div>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Close</v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="!valid"
            @click="validate"
            >{{ itemToedit.length ? 'Save Menu' : 'Add Menu' }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="element_dialog" persistent scrollable max-width="600px">
      <v-card>
        <v-card-title
          ><span>{{ $vuetify.lang.t('$vuetify.company.addElement') }}</span>
          <v-spacer></v-spacer
          ><v-btn icon @click="clearEleValue">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col>
              <p class="mb-2 body-1 font-weight-medium">
                {{ $vuetify.lang.t('$vuetify.company.contentTemplate') }}
              </p>
              <v-autocomplete
                v-model="selectedEle"
                :items="type_ele_item"
                item-text="text"
                item-value="value"
                outlined
                :placeholder="$vuetify.lang.t('$vuetify.company.msg18')"
              ></v-autocomplete>
              <p
                v-if="selectedEle == 'course_vertical_gridview'"
                class="mb-2 body-1 font-weight-medium"
              >
                เลือกหมวดหมู่คอร์ส
              </p>
              <v-combobox
                v-if="selectedEle == 'course_vertical_gridview'"
                v-model="selectedCategory"
                :items="category"
                item-text="title"
                :placeholder="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.plsChooseCategories'
                  )
                "
                item-value="_id"
                outlined
                dense
                multiple
                required
                small-chips
                background-color="white"
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    class="ma-1"
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.title }}
                    </span>
                    <v-icon small @click="parent.selectItem(item)">
                      mdi-close-circle
                    </v-icon>
                  </v-chip>
                </template></v-combobox
              >
              <p class="mb-2 body-1 font-weight-medium">
                {{ $vuetify.lang.t('$vuetify.company.elementTitle') }}
              </p>
              <v-text-field
                :placeholder="$vuetify.lang.t('$vuetify.company.msg19')"
                v-model="ele_name"
                outlined
              ></v-text-field>
              <p class="mb-2 body-1 font-weight-medium">
                {{ $vuetify.lang.t('$vuetify.company.elementDescription') }}
              </p>
              <v-textarea
                outlined
                v-model="ele_description"
                :placeholder="$vuetify.lang.t('$vuetify.company.msg20')"
                name="input-7-4"
              ></v-textarea>
              <p
                class="mb-2 body-1 font-weight-medium"
                style="color: rgba(0, 0, 0, 0.6)"
              >
                {{ $vuetify.lang.t('$vuetify.company.ContentSetting') }}
              </p>
              <v-sheet width="100%" color="#f4f4f4" class="pr-3 pt-3 pl-3">
                <p class="mb-2 body-1 font-weight-medium">
                  {{ $vuetify.lang.t('$vuetify.company.orderBy') }}
                </p>
                <!-- <v-autocomplete
                  v-model="oderBy"
                  :items="sort_item"
                  item-text="sort_name"
                  item-value="type"
                  outlined
                  :placeholder="$vuetify.lang.t('$vuetify.company.msg21')"
                  background-color="white"
                ></v-autocomplete> -->
                <v-autocomplete
                  v-model="oderBy"
                  :items="sort_item"
                  item-text="sort_name"
                  item-value="sort_name"
                  outlined
                  :placeholder="$vuetify.lang.t('$vuetify.company.msg21')"
                  background-color="white"
                ></v-autocomplete>
                <!--
                <p class="mb-2 body-1 font-weight-medium">
                  {{ $vuetify.lang.t("$vuetify.company.displayItemLimit") }}
                </p>
                <v-row>
                  <v-col class="py-0" lg="3">
                    <p class="mb-0 pt-1">
                      {{ $vuetify.lang.t("$vuetify.company.mobile") }}:
                    </p>
                  </v-col>
                  <v-col class="py-0" lg="4">
                    <v-text-field
                      type="number"
                      min="0"
                      placeholder="Number"
                      v-model="mobile_item"
                      outlined
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" lg="3">
                    <p class="mb-0 pt-1">
                      {{ $vuetify.lang.t("$vuetify.company.tablet") }}:
                    </p>
                  </v-col>
                  <v-col class="py-0" lg="4">
                    <v-text-field
                      type="number"
                      min="0"
                      placeholder="Number"
                      v-model="tablet_item"
                      outlined
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" lg="3">
                    <p class="mb-0 pt-1">
                      {{ $vuetify.lang.t("$vuetify.company.desktop") }}:
                    </p>
                  </v-col>
                  <v-col class="py-0" lg="4">
                    <v-text-field
                      type="number"
                      min="0"
                      placeholder="Number"
                      v-model="desktop_item"
                      outlined
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                </v-row>
                -->
              </v-sheet>
              <!-- <div v-if="selectedEle !== 'banner_slider'">
                <p class="mb-2 body-1 font-weight-medium">
                  See More button position
                </p>
                <v-radio-group v-model="position_button" row>
                  <v-radio label="Top" value="top"></v-radio>
                  <v-radio label="Bottom" value="bottom"></v-radio>
                </v-radio-group>
              </div> -->
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="
              px-9
              ma-2
              subtitle-2
              button-secondary
              font-weight-light
              text-capitalize
            "
            outlined
            @click="clearEleValue"
            >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
          >
          <v-btn
            :disabled="!selectedEle"
            elevation="0"
            class="
              px-10
              ma-2
              subtitle-2
              text-capitalize
              font-weight-light
              button-primary
            "
            @click="saveSetting"
            >{{ $vuetify.lang.t('$vuetify.company.save') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalDelWarrning" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.company.msg10')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t('$vuetify.company.msg11')
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey "
            class="px-9 ma-2"
            dark
            outlined
            @click="modalDelWarrning = false"
            >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
          >
          <v-btn color="error " class="px-10 ma-2" @click="delElement">{{
            $vuetify.lang.t('$vuetify.company.confirm')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delMenudialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.company.msg12')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t('$vuetify.company.msg13')
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey "
            class="px-9 ma-2"
            dark
            outlined
            @click="delMenudialog = false"
            >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
          >
          <v-btn color="error" class="px-10 ma-2" dark @click="delMenuBar">{{
            $vuetify.lang.t('$vuetify.company.confirm')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warningDialog" persistent max-width="500">
      <v-card class="pt-10">
        <v-card-text class="subtitle-1">{{ warning }}</v-card-text>
        <!--<v-card-title class="headline text-center">{{warning}}</v-card-title>-->
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-center">
            <v-btn
              color="primary "
              class="white--text"
              outlined
              @click="initialize"
              >{{ $vuetify.lang.t('$vuetify.company.ok') }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.courseList.sorry')
        }}</v-card-title>
        <v-card-text>
          <div
            v-html="
              $vuetify.lang.t(
                '$vuetify.courseManagement.courseList.alertPermissionFunction'
              )
            "
          ></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="alert = false">{{
            $vuetify.lang.t('$vuetify.courseManagement.courseList.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="alert_nosetting" persistent max-width="450">
      <v-card>
        <v-card-title class="headline"
          >การตั้งค่าเมนูยังไม่สมบูรณ์</v-card-title
        >
        <v-card-text>
          <div>
            เนื่องจากไม่มีการ "เพิ่มเมนู" ชนิด "การตั้งค่า(setting)"
            กรุณาเพิ่มเมนู "การตั้งค่า"
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="alert_nosetting = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.courseList.ok')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="dialogMenuSuccess" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.company.msg15')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t('$vuetify.company.msg16')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogMenuSuccess = false"
            >{{ $vuetify.lang.t('$vuetify.company.done') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogElementSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.company.msg15')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t('$vuetify.company.msg17')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogElementSuccess = false"
            >{{ $vuetify.lang.t('$vuetify.company.done') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteSuccess" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.warningMsg1'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.warningMsg2'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogMenuSuccess = false"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.accessStep.manageLearners.done'
              )
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  getMenu,
  inserMenu,
  updateMenu,
  deleteMenu,
  activeMenu,
  setPiorityMenu,
  setPiorityElement,
} from '@/service/company/setting';
import { loadCategory } from '@/service/category/category';
import draggable from 'vuedraggable';
import warnningComponent from '../../components/warningAlert.vue';
import $ from 'jquery';
export default {
  components: {
    draggable,
    // warnningComponent,
  },
  props: {
    id: {
      type: String,
    },
  },
  async mounted() {
    // this.getBorder();
    await this.initialize();
  },
  el: '#toolBtns',
  data() {
    return {
      dialogDeleteSuccess: false,
      valid: true,
      //item  type
      menuList: [],
      newMenu: true,
      activeBtn: '',
      category: [],
      selectedCategory: [],
      type_item: [
        {
          type_name: 'Overview',
          value: 'overview',
        },
        {
          type_name: 'My Course',
          value: 'mycourse',
        },
        {
          type_name: 'Search',
          value: 'search',
        },
        {
          type_name: 'Notification',
          value: 'notification',
        },
        {
          type_name: 'Setting',
          value: 'setting',
        },
      ],
      icon_list: [
        {
          icon_name: 'home',
        },
        {
          icon_name: 'search',
        },
        {
          icon_name: 'video',
        },
        {
          icon_name: 'book',
        },
        {
          icon_name: 'chat',
        },
        {
          icon_name: 'info',
        },
        {
          icon_name: 'email',
        },
        {
          icon_name: 'user',
        },

        {
          icon_name: 'notification',
        },
        {
          icon_name: 'setting',
        },
      ],
      heightCard: '200px',
      icon: {
        home: 'mdi-home-outline',
        search: 'mdi-magnify',
        course: 'mdi-play-box-outline',
        setting: 'mdi-account-outline',
        video: 'mdi-play-box-outline',
        book: 'mdi-book',
        chat: 'mdi-chat-processing',
        info: 'mdi-information-outline',
        email: 'mdi-email-outline',
        user: 'mdi-account-multiple',
        notification: 'mdi-bell-outline',
      },

      type_ele_item: [
        {
          text: 'Banner',
          value: 'banner_slider',
        },
        // catagory
        {
          text: 'Category List',
          value: 'category_horizontal_listview',
        },

        // Grade
        // {
        //   text: "Grade",
        //   value: "grade_horizontal_listview",
        // },

        //course
        {
          text: 'Recomanded Course',
          value: 'course_vertical_gridview',
        },
        // {
        //   text: "Horizontal Course ",
        //   value: "course_horizontal_gridview",
        // },

        {
          text: 'My Course ',
          value: 'my_course_vertical_gridview',
        },
        // {
        //   text: "Horizontal My Course ",
        //   value: "my_course_horizontal_gridview",
        // },

        // {
        //   text: "Vertical examination ",
        //   value: "examination_vertical_gridview",
        // },
        // {
        //   text: "Horizontal Article ",
        //   value: "article_horizontal_listview",
        // },
        // {
        //   text: "Vertical Book ",
        //   value: "book_vertical_gridview",
        // },
        // {
        //   text: "Instructor",
        //   value: "teacher_horizontal_listview",
        // },
        //{
        //  text: "Tag List",
        //  value: "tag_list",
        //},

        // { text: "Web View", value: "show_web_view" },
        //{ text: "Category List", value: "show_category_list" },
        //{
        //text: "Category List By Keyword",
        //value: "show_category_list_search"
        //},
        //{ text: "Grade List", value: "show_grade_list" },
        //{ text: "Grade List By Keyword", value: "show_grade_list_search" },
        //{ text: "SKill List", value: "show_tag_list" },
        //{ text: "SKill List By Keyword", value: "show_tag_list_search" },
        //{ text: "Teacher List", value: "show_teacher_list" },
        //{ text: "Teacher List By Keyword", value: "show_teacher_list_search" },
        //{ text: "Course List", value: "show_course_list" },
        //{ text: "Course List By Keyword", value: "show_course_list_search" },
        //{ text: "Course Detail", value: "show_course_detail" },

        //{ text: "Exam List", value: "show_exam_list" },
        //{ text: "Exam Detail", value: "show_exam_detail" },

        //{ text: "Book List", value: "show_book_list" },
        //{ text: "Book  Detail", value: "show_book_detail" },

        //{ text: "My Course", value: "show_my_course_list" }
      ],

      ele_list: [],
      sort_item: [
        // {
        //   sort_name: 'Popular',
        //   type: 'popular',
        // },
        {
          sort_name: 'New',
          type: 'created_at',
        },
        // {
        //   sort_name: 'Random',
        //   type: 'random',
        // },
        {
          sort_name: 'Priority',
          type: 'priority',
        },
        {
          sort_name: 'Name',
          type: 'title',
        },
        // {
        //   sort_name: 'Interest',
        //   type: 'interest',
        // },
        {
          sort_name: 'Created At',
          type: 'created_at',
        },
      ],

      // select item
      selectedIcon: '',
      selectedSection: '',
      menu_title: '',

      //Element
      selectedEle: '',
      ele_name: '',
      ele_description: '',
      oderBy: '',
      mobile_item: 0,
      tablet_item: 0,
      desktop_item: 0,
      position_button: 'top',

      // dialog
      dialog: false,
      element_dialog: false,
      modalDelWarrning: false,
      delMenudialog: false,
      warningDialog: false,
      alert: false,
      alert_nosetting: false,
      dialogMenuSuccess: false,
      dialogElementSuccess: false,

      //rule
      nameRules: [(v) => !!v || 'Name is required'],
      sectionRules: [(v) => !!v || 'Please Choose The Item'],

      itemToedit: [],
      eleItemToedit: [],

      del_menu: '',
      warning: '',

      //warning
      textWarning: '',
      typeWarning: '',
      showWarnnig: false,
      menuListClicked: false,
    };
  },
  methods: {
    async initialize() {
      // select item
      this.selectedIcon = '';
      this.selectedSection = '';
      this.menu_title = '';
      this.itemToedit = [];
      this.dialog = false;
      this.element_dialog = false;
      this.modalDelWarrning = false;
      this.delMenudialog = false;
      this.warningDialog = false;
      this.getmenuTab();
      await this.getCategoryList();
    },
    async getCategoryList() {
      this.category = await loadCategory();
    },
    async validate() {
      if (this.$refs.form.validate()) {
        if (this.itemToedit.length !== 0) {
          let item = this.itemToedit;
          let data = {
            ...item,
            id: this.itemToedit._id,
            name: this.menu_title,
            icon: this.selectedIcon,
            type: this.selectedSection,
            company: this.id,
            setting: this.ele_list,
          };
          let result = await updateMenu(data);
          if (result) {
            this.dialogMenuSuccess = true;
            this.initialize();
            this.closeDialog();
          }
        } else {
          let data = {
            name: this.menu_title,
            icon: this.selectedIcon,
            type: this.selectedSection,
            company: this.id,
            setting: this.ele_list,
          };
          let result = await inserMenu(data);
          if (result) {
            this.dialogMenuSuccess = true;
            this.initialize();
            this.closeDialog();
          }
        }
      } else return;
    },
    closeDialog() {
      this.selectedIcon = '';
      this.selectedSection = '';
      this.menu_title = '';
      this.itemToedit = [];
      this.dialog = false;
      this.newMenu = true;
      this.$refs.form.resetValidation();
      this.initialize();
    },

    openModal(item) {
      this.menuListClicked = true;
      if (item) {
        this.getBorder();
        this.newMenu = false;
        this.itemToedit = item;
        this.selectedIcon = item.icon;
        this.selectedSection = item.type;
        this.menu_title = item.name;
        this.ele_list = item.setting;
        // this.dialog = true;
      } else {
        // this.dialog = true;
        this.ele_list = [];
        this.newMenu = true;
        this.selectedIcon = '';
        this.selectedSection = '';
        this.menu_title = '';
        this.itemToedit = [];
        this.$refs.form.resetValidation();
      }
    },
    openElementModal(item) {
      this.eleItemToedit = item;
      console.log('openElementModal -> item', item);
      let editOrderBy = '';
      if (item) {
        if (item.sortMethod == 'created_at' && item.sortBy == 1) {
          editOrderBy = 'New';
        } else if (item.sortMethod == 'created_at' && item.sortBy == -1) {
          editOrderBy = 'Created At';
        } else if (
          item.sortMethod == 'displayName' ||
          item.sortMethod == 'title'
        ) {
          editOrderBy = 'Name';
        } else if (item.sortMethod == 'priority') {
          editOrderBy = 'Priority';
        }

        if (
          (item.categories != null || item.categories.length) &&
          this.category.length
        ) {
          item.categories.forEach((idcategory) => {
            this.category.forEach((itemcategory) => {
              if (idcategory == itemcategory._id) {
                this.selectedCategory.push(itemcategory);
              }
            });
          });
        }
        this.selectedEle = item.type;
        this.ele_name = item.title;
        this.ele_description = item.description;
        this.oderBy = editOrderBy;
        this.mobile_item = item.mobileItem;
        this.tablet_item = item.tabletItem;
        this.desktop_item = item.desktopItem;
        this.position_button =
          item.showButtonHeader === true
            ? 'top'
            : item.showButtonFooter === true
            ? 'bottom'
            : '';

        this.element_dialog = true;
      } else {
        this.element_dialog = true;
      }
    },
    async getmenuTab() {
      let params = {
        company: this.id,
      };
      let result = await getMenu(params);
      if (result.status == false) {
        this.noPermission();
      } else {
        this.menuList = result;
        // let setting = result.filter((filter) => filter.type == 'setting');
        // setting.length == 0 ? (this.alert_nosetting = true) : '';
      }
    },
    changType() {
      this.heightCard = this.selectedSection == 'overview' ? '500px' : '300px';
      if (this.selectedSection == 'overview') {
        this.selectedIcon = 'home';
        this.menu_title = 'Home';
      } else if (this.selectedSection == 'mycourse') {
        this.selectedIcon = 'video';
        this.menu_title = 'My Course';
      } else if (this.selectedSection == 'search') {
        this.selectedIcon = 'search';
        this.menu_title = 'Search';
      } else if (this.selectedSection == 'notification') {
        this.selectedIcon = 'notification';
        this.menu_title = 'Notification';
      } else if (this.selectedSection == 'setting') {
        this.selectedIcon = 'setting';
        this.menu_title = 'Setting';
      } else {
        this.selectedIcon = 'home';
        this.menu_title = 'Home';
      }
    },
    clearEleValue() {
      //Element
      this.selectedEle = '';
      this.ele_name = '';
      this.ele_description = '';
      this.oderBy = '';
      this.mobile_item = 0;
      this.tablet_item = 0;
      this.desktop_item = 0;
      this.position_button = 'top';

      this.selectedCategory = [];
      this.element_dialog = false;
    },
    async saveSetting() {
      switch (this.selectedEle) {
        case 'banner_slider':
          this.desktop_item = 10;
          this.tablet_item = 10;
          this.mobile_item = 10;
          break;
        case 'category_horizontal_listview':
          this.desktop_item = 10;
          this.tablet_item = 10;
          this.mobile_item = 10;
          break;
        case 'course_vertical_gridview':
          this.desktop_item = 6;
          this.tablet_item = 4;
          this.mobile_item = 4;
          break;
        case 'my_course_vertical_gridview':
          this.desktop_item = 6;
          this.tablet_item = 4;
          this.mobile_item = 4;
          break;
        default:
          this.desktop_item = 10;
          this.tablet_item = 10;
          this.mobile_item = 10;
          break;
      }
      let arrIdCategory = [];
      if (this.selectedCategory.length > 0) {
        this.selectedCategory.forEach((category) => {
          arrIdCategory.push(category._id);
        });
      }
      let sortSetting = {};
      if (this.oderBy == 'New') {
        sortSetting = { type: 'created_at', sort_by: 1 };
      } else if (this.oderBy == 'Created At') {
        sortSetting = { type: 'created_at', sort_by: -1 };
      } else if (this.oderBy == 'Name') {
        if (this.oderBy == 'Name' && this.selectedEle == 'Instructor') {
          sortSetting = { type: 'displayName', sort_by: -1 };
        } else {
          sortSetting = { type: 'title', sort_by: -1 };
        }
      } else if (this.oderBy == 'Priority') {
        sortSetting = { type: 'priority', sort_by: -1 };
      }

      if (
        this.itemToedit.setting &&
        this.ele_list.indexOf(this.eleItemToedit) !== -1
      ) {
        let index = this.ele_list.indexOf(this.eleItemToedit);
        let edit_ele = this.ele_list[index];
        this.selectedEle == 'banner_slider' ? (this.position_button = '') : '';

        let data = {
          ...edit_ele,
          title: this.ele_name,
          description: this.ele_description,
          desktopItem: this.desktop_item,
          mobileItem: this.mobile_item,
          tabletItem: this.tablet_item,
          colorButtonFooter: '',
          colorButtonHeader: '',
          type: this.selectedEle,
          sortMethod: sortSetting.type,
          sortBy: sortSetting.sort_by,
          categories: arrIdCategory,
          priority: this.ele_list.length,
        };
        this.position_button == 'top'
          ? (data.showButtonHeader = true)
          : (data.showButtonHeader = false);
        this.position_button == 'bottom'
          ? (data.showButtonFooter = true)
          : (data.showButtonFooter = false);
        this.ele_list[index] = data;
        let data2 = {
          ...this.itemToedit,
          id: this.itemToedit._id,
          name: this.menu_title,
          icon: this.selectedIcon,
          type: this.selectedSection,
          company: this.id,
          setting: this.ele_list,
          categories: arrIdCategory,
        };
        let result = await updateMenu(data2);
        if (result) {
          this.getmenuTab();
        }
        // await this.validate();
        this.dialogElementSuccess = true;
        this.clearEleValue();
      } else {
        this.selectedEle == 'banner_slider' ? (this.position_button = '') : '';
        let data = {
          title: this.ele_name,
          description: this.ele_description,
          desktopItem: this.desktop_item,
          mobileItem: this.mobile_item,
          tabletItem: this.tablet_item,
          colorButtonFooter: '',
          colorButtonHeader: '',
          type: this.selectedEle,
          sortMethod: sortSetting.type,
          sortBy: sortSetting.sort_by,
          showButtonFooter: '',
          showButtonHeader: '',
          categories: arrIdCategory,
          priority: this.ele_list.length,
        };
        this.position_button == 'top'
          ? (data.showButtonHeader = true)
          : (data.showButtonHeader = false);
        this.position_button == 'bottom'
          ? (data.showButtonFooter = true)
          : (data.showButtonFooter = false);

        this.ele_list.push(data);
        let data2 = {
          ...this.itemToedit,
          id: this.itemToedit._id,
          name: this.menu_title,
          icon: this.selectedIcon,
          type: this.selectedSection,
          company: this.id,
          setting: this.ele_list,
          categories: arrIdCategory,
        };
        let result = await updateMenu(data2);
        if (result) {
          this.getmenuTab();
        }
        // await this.validate();
        this.dialogElementSuccess = true;
        this.clearEleValue();
      }
    },
    opendelModal(item) {
      this.modalDelWarrning = true;
      this.eleItemToedit = item;
    },
    delElement() {
      let index = this.ele_list.indexOf(this.eleItemToedit);
      this.ele_list.splice(index, 1);
      this.modalDelWarrning = false;
      this.clearEleValue();
    },
    openDelDialog(id) {
      this.del_menu = id;
      this.delMenudialog = true;
    },
    async delMenuBar() {
      let data = {
        id: this.del_menu,
      };

      let activeStatus = await activeMenu({
        active: false,
        id: this.del_menu,
        company: this.id,
      });
      if (activeStatus._id) {
        let status = await deleteMenu(data);
        if (status.delete) {
          this.delMenudialog = false;

          this.warnnig('Delete Menu Succes', 'success');

          // this.warningDialog = true;
          // this.warning = "Delete Menu Success";
        } else {
          this.delMenudialog = false;
          // this.warningDialog = true;
          this.warnnig('Delete Menu Fail', 'error');
          // this.warning = "Delete Menu Fail";
        }
        this.initialize();
      } else {
        this.delMenudialog = false;
        this.warningDialog = true;
        this.warning = 'Delete Menu Fail';
      }
    },
    noPermission() {
      this.alert = true;
    },
    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
      }, 2000);
    },
    getBorder() {
      let header = $('#myDIV');
      if (header.hasClass('card-item')) {
        header.addClass('border-active');
      }
      // var btns = header.hasClass('card-item');
      // for (var i = 0; i < btns.length; i++) {
      //   btns[i].addEventListener('click', function () {
      //     var current = document.getElementsByClassName('border-active');
      //     if (current.length > 0) {
      //       current[0].className = current[0].className.replace(
      //         ' border-active',
      //         ''
      //       );
      //     }
      //     this.className += ' border-active';
      //   });
      // }
    },
    checkMoveMenu() {
      let menuId = this.menuList.map((item) => item._id);
      this.setPiorityMenu(menuId);
    },
    checkMoveElement(menuItem) {
      let menuId = menuItem._id;
      let elementId = menuItem.setting.map((element) => element._id);
      this.setPiorityElement(menuId, elementId);
    },
    async setPiorityMenu(menuId) {
      await setPiorityMenu({
        arrayid: menuId,
      });
      this.getmenuTab();
    },
    async setPiorityElement(menuId, elementId) {
      await setPiorityElement({
        id: menuId,
        arrayid: elementId,
      });
      this.getmenuTab();
    },
  },
};
</script>

<style scoped lang="scss">
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.sheet-style {
  width: 100%;
  height: 100%;
}
.border-card {
  border: 2px dashed rgba(74, 144, 226, 0.5) !important;
  &:hover {
    border: 2px dashed rgba(74, 144, 226, 0.5) !important;
    background-color: aliceblue;
    color: #4a90e2 !important;
  }
}
.border-card-active {
  border: 2px dashed rgba(74, 144, 226, 0.5) !important;
  background-color: aliceblue;
  color: #4a90e2 !important;
}
.bg-color {
  background-color: aliceblue;
}
.text-active {
  color: #4a90e2 !important;
}
.card-item {
  background-color: white;

  // &:active {
  //   font-weight: 700 !important;
  //   background-color: aliceblue;
  //   border-color: #4a90e2;
  // }
}
.border-active {
  font-weight: 700 !important;
  background-color: aliceblue;
  border-color: #4a90e2;
}
.toolbar-style {
  display: flex;
  justify-content: center;
}
.menu-item {
  min-height: 100px;
  width: 20%;
  // border: 1px solid #e8e8e8;
  position: relative;
  margin: 0 10px;
  flex-wrap: nowrap;
  background: #fff;
  border-radius: 4px;

  &:hover {
    cursor: pointer;
  }
}

.justify-center {
  justify-content: center;
}

.content {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff !important;
  p {
    color: #4a4a4a;
  }
}

.have-border {
  border: 1px dashed #afafaf !important;
}

.text-grey {
  color: #afafaf;
}

.ele-list .v-list-item {
  border-bottom: 1px solid #e8e8e8;
}

.custom-border {
  border: 1px solid #ccc !important;
}

.main-card {
  margin: 0 auto;
  background: #f0f2f5;
}

.list-menu {
  flex-wrap: wrap;
}

.del-com {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ef9a9a;
  border-radius: 50px;
  width: 20px;
  height: 20px;
  padding-left: 2px;
  z-index: 1;

  i {
    color: #fff;
  }
}

.content-panel {
  height: 100%;
  width: 100%;
}
</style>
